import type { FC } from 'react';
import styled from 'styled-components';
import type { FavoriteButtonProps } from '@n3/pn-declaration';
import { useSettings } from '@n3/pn-core';
import StarIcon from '@material-ui/icons/Star';

const StyledWrapperButton = styled.button<{
  $isAdded?: boolean;
}>(
  ({
    $isAdded,

    theme: {
      colors: { dark, white },

      fonts: { h4 },
    },

    disabled,
  }) => ({
    ...h4,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    border: 'none',
    backgroundColor: $isAdded ? '#F33C85' : white,
    color: $isAdded ? white : dark,
    paddingRight: 30,
    paddingLeft: 20,
    height: 50,
    margin: 0,
    outline: 'none',
    cursor: disabled ? 'default' : 'pointer',
    borderTopLeftRadius: 25,
    borderBottomLeftRadius: 25,
  })
);

const StyledStarWrapper = styled.span<{
  $isAdded?: boolean;
}>(({ $isAdded }) => ({
  display: 'inline-flex',
  fontSize: 30,
  marginRight: 5,
  color: $isAdded ? 'inherit' : '#F33C85',
}));

export const FavoriteButton: FC<FavoriteButtonProps> = ({ isAdded, onChange, disabled }) => {
  const {
    FavoriteButton: { addedLabel, notAddedLabel },
  } = useSettings();

  const onClick = () => {
    onChange(!isAdded);
  };

  return (
    <StyledWrapperButton type="button" $isAdded={isAdded} disabled={disabled} onClick={onClick}>
      <StyledStarWrapper $isAdded={isAdded}>
        <StarIcon fontSize="inherit" />
      </StyledStarWrapper>

      {isAdded ? addedLabel : notAddedLabel}
    </StyledWrapperButton>
  );
};
